import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  image: {
    maxWidth: "200px",
    // Mobile portrait
    "@media (max-width: 414px)": {
      marginTop: "30px"
    },
    // Mobile landscape
    "@media (max-width: 823px) and (max-height: 414px)": {
      marginTop: "5px",
      marginBottom: 0,
      width: "100px",
      maxWidth: "100px"
    }
  }
});

const SvgImage = ({ alt, src, classes, className }) => (
  <div className={`${classes.container} ${className}`}>
    <img src={src} alt={alt} className={classes.image} />
  </div>
);

SvgImage.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  classes: PropTypes.object,
  className: PropTypes.string
};

export default injectSheet(styles)(SvgImage);



// WEBPACK FOOTER //
// ./src/components/SvgImage.jsx